// extracted by mini-css-extract-plugin
export default {"chipWrap":"chipsFilter_chipWrap__5q3jl"};